type IdLike = string | number | bigint | null | undefined;

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' &&
  value !== null &&
  !Array.isArray(value) &&
  !(value instanceof Date);

const isIdKey = (key: string) =>
  key === 'id' || key.endsWith('Id') || key.endsWith('_id');

const toIdString = (value: IdLike): string =>
  value === null || value === undefined ? '' : value.toString();

export const normalizeIds = <T>(input: T): T => {
  if (Array.isArray(input)) {
    return input.map(item => normalizeIds(item)) as T;
  }

  if (isPlainObject(input)) {
    const result: Record<string, unknown> = {};

    Object.entries(input).forEach(([key, value]) => {
      if (
        isIdKey(key) &&
        (typeof value === 'string' ||
          typeof value === 'number' ||
          typeof value === 'bigint')
      ) {
        result[key] = toIdString(value);
      } else if (Array.isArray(value) || isPlainObject(value)) {
        result[key] = normalizeIds(value);
      } else {
        result[key] = value;
      }
    });

    return result as T;
  }

  return input;
};
